import script from "./QueroVender.vue?vue&type=script&setup=true&lang=js"
export * from "./QueroVender.vue?vue&type=script&setup=true&lang=js"

import "./QueroVender.vue?vue&type=style&index=0&id=1ce8185e&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce8185e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QForm,QInput,QIcon,QBtn});
